import React from "react";
import { MdCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import EAButton from "../../../shared/Buttons/EAButton";
import { Instructor } from "../../../../models/Instructor";
import getId from "../../../../../utils/getId";

interface IProps {
  title: string;
  data: Instructor[];
  selectedValue?: Instructor;
  onSelect: (value: Instructor) => void;
}
const InstructorSortModal: React.FC<IProps> = ({ title, data, selectedValue, onSelect }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      <p>{title}</p>
      <div className="SortModal">
        {data.map((item, index) => {
          const isSelected = selectedValue && getId(item) === getId(selectedValue);
          return (
            <EAButton
              key={index}
              onClick={() => onSelect(item)}
              title={`${item.firstName}`}
              startIcon={isSelected ? <MdCheckBox /> : <MdOutlineCheckBoxOutlineBlank />}
              variant="text"
              noMargins
            />
          );
        })}
      </div>
    </>
  );
};

export default InstructorSortModal;
